module.exports = __webpack_public_path__ + "img/advance.5c87ad91.svg";